export const caboPhotos = [
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596931/cabo/16-dsc_2551_wluz2f.jpg',
    width: 1060,
    height: 706,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596931/cabo/98585-group-1_zey5zi.jpg',
    width: 476,
    height: 608,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596932/cabo/c02eda20067d0c442bb8336e4b83b57f_pt6kpj.jpg',
    width: 735,
    height: 490,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596931/cabo/9e51d9e79f6185430736b607a00a47b587bdfa6c_original_ymz74l.jpg',
    width: 1000,
    height: 1000,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596935/cabo/E9ghq7CXsAAR9NX_mndggq.jpg',
    width: 1200,
    height: 800,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596941/cabo/IWX-0618-056_ziuuip.jpg',
    width: 880,
    height: 588,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596945/cabo/versatile-high-waist-tie-dye-tie-string-brazilian-two-piece-bikini-swimsuit-Multicolor-1_600x_bggl4z.jpg',
    width: 600,
    height: 600,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596944/cabo/rBVak184hgaAPuOTAAT9jGSQ9J0592_fujsyi.jpg',
    width: 800,
    height: 800,
  },

  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704596945/cabo/sexy-high-cut-strappy-cutout-front-brazilian-one-piece-swimsuit-Pink-1_600x_dxwoqt.jpg',
    width: 600,
    height: 600,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704602028/cabo/Facetune_07-02-2021-07-31-29-scaled_hlxpda.jpg',
    width: 2048,
    height: 1365,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704602029/cabo/HorseBackRiding-15_wpf6en.jpg',
    width: 3072,
    height: 2304,
  },

  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704602028/cabo/D35yS11UEAAG36e_x6qcax.jpg',
    width: 1657,
    height: 1657,
  },
  {
    src: 'https://res.cloudinary.com/dzsf703vh/image/upload/v1704602027/cabo/360553f5cb12263025e441c86653a138_plburn.png',
    width: 481,
    height: 577,
  },
];
